var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/moral.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-85640c56!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/moral.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Moral.vue
// module id = 649
// module chunks = 1